import {
    ADD_THANK_YOU,
    EDIT_THANK_YOU,
    LIST_THANK_YOU,
    VIEW_THANK_YOU,
    DELETE_THANK_YOU,

    THANK_YOU_SUCCESS,
    THANK_YOU_ERROR,
  
  } from "./actionTypes"
  const initialState = {
    successMsg: null,
    error: null,
    editLoading:false
  }
  
  const configSurveyThankYou = (state = initialState, action) => {
    switch (action.type) {
  
      // add THANK_YOU
      case ADD_THANK_YOU:
        state = {
          ...state,
          editLoading: true,
          successMsg: null,
          error: null,
        }
        break
      case THANK_YOU_SUCCESS:
        state = {
          ...state,
          loading: false,
          successMsg: action.payload,
          editLoading:false
        }
        break
      case THANK_YOU_ERROR:
        state = { ...state, error: action.payload, loading: false,editLoading:false }
        break
  
      // edit THANK_YOU
      case EDIT_THANK_YOU:
        state = {
          ...state,
          editLoading: true,
          successMsg: null,
          error: null,
        }
        break
  
      // list THANK_YOU
      case LIST_THANK_YOU:
        state = {
          ...state,
          loading: true,
          successMsg: null,
          error: null,
        }
        break
  
      // view THANK_YOU
      case VIEW_THANK_YOU:
        state = {
          ...state,
          successMsg: null,
          error: null,
        }
        break
  
      // delete THANK_YOU
      case DELETE_THANK_YOU:
        state = {
          ...state,
          loading: true,
          successMsg: null,
          error: null,
        }
        break

      default:
        state = { ...state }
        break
    }
    return state
  }
  
  export default configSurveyThankYou
  